export default __webpack_public_path__ + "1e1d3306dd19f0a3d1032e6db987c7da.png";